import * as HLF from "html-living-framework";

export class Focusables {

    public static get enabled() {
        return this._enabled;
    }

    public static set enabled(value: boolean) {
        if (this._enabled !== value) {
            this._enabled = value;
            if (value) {
                PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, true);
            } else {
                PubSub.publishSync(HLF.CLEAR_FOCUS, undefined);
                PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, false);
            }
        }
    }

    private static _enabled = true;

    public static add(...focusables: HLF.Input.IFocusable[]) {
        if (focusables.length === 0) {
            return;
        }
        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, focusables);
    }

    public static remove(...focusables: Array<HLF.Input.IFocusable | ((it: HLF.Input.IFocusable) => boolean)>): void {
        if (focusables.length === 0) {
            return;
        }
        PubSub.publishSync(HLF.UNREGISTER_FOCUSABLES, focusables);
    }

    public static clear() {
        PubSub.publishSync(HLF.UNREGISTER_ALL_FOCUSABLES, undefined);
    }
}
